const defaultAllowOverrideBehaviour = {
  canOverrideUnsupportedMark: () => {
    return true;
  }
};
const defaultDoNotAllowOverrideBehaviour = {
  canOverrideUnsupportedMark: () => {
    return false;
  }
};
export const markOverrideRuleFor = type => {
  switch (type) {
    case 'link':
    case 'em':
    case 'strong':
    case 'strike':
    case 'subsup':
    case 'underline':
    case 'code':
    case 'textColor':
    case 'backgroundColor':
    case 'confluenceInlineComment':
    case 'breakout':
    case 'alignment':
    case 'indentation':
    case 'border':
      return defaultAllowOverrideBehaviour;
    default:
      return defaultDoNotAllowOverrideBehaviour;
  }
};